import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import StaffPage from '../../views/StaffPage/';

class Usertype extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			usertype : '',
			_message : '',
			alertClass :'',
			posts : [],
			isedit : 0,
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onUpdateSubmit = this.onUpdateSubmit.bind(this);
		this.onClick = this.onClick.bind(this);
	}

	onClick(e){
		document.getElementById("editform").reset();
		this.setState({isedit : 0,usertype : ''});
		$("#usertype").val('');
		document.getElementById("userform").reset();
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		
		if (window.confirm("Do you want to Delete?")) {
				$("#showLoader").show();
			PostData('usertype/deleteusertype',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'UserType Removed Successfully',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove UserType',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
		
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.usertype){
			$("#showLoader").show();
			PostData('usertype/add',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				// console.log(responseJson);
				if(responseJson.status == '1' ){
					this.setState({
						_message:'UserType Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("userform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'UserType Already Added..',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}

	onUpdateSubmit(e){
		e.preventDefault();
		
		if(this.state.usertype){
			$("#showLoader").show();
			PostData('usertype/edit',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				
				if(responseJson.status == '1' ){
					document.getElementById("editform").reset();
					this.setState({
						_message:'UserType Updated Successfully!..',
						alertClass:'alert alert-success',
						isedit : 0
					});
					this.getdata();
				}
				else{
					this.setState({
						_message:'UserType Already Added..',
						alertClass:'alert alert-danger'
					});
				}
			});	
		}
	}

	handleEditClick(id){

		var index = this.state.posts.findIndex(function(obj){
			return (obj.id == id);
		})
		this.setState({usertype : this.state.posts[index]['usertype'], id :id,isedit : 1});
	}
	
	componentDidMount() {
		 
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('usertype/getusertype').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
  render() {
	  
    return (
		<div>
		  <StaffPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				
				<Row>
					{this.state.isedit == 0 ?
				  <Col md="5">
					<Card>
					  <form action="" method="post" role="form" id="userform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Add UserType</strong>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">User Type <span className="text-danger">*</span></Label>
								  <Input type="text" name="usertype" id="usertype" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
					</Col> : 
					<Col md="5">
					<Card>
					  <form action="" method="post" role="form" id="editform" encType="multipart/form-data" onSubmit={this.onUpdateSubmit} >
						<CardHeader>
							<strong>Edit UserType</strong>
							<button style={{float : 'right'}} className="btn btn-primary btn-sm" onClick={this.onClick}>Add</button>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">User Type <span className="text-danger">*</span></Label>
								  <Input type="text" name="usertype" required onChange={this.onChange} value={this.state.usertype} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
					}
				  <Col md="7">
				   <Card>
					<CardBody>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>User Type</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.posts.map(item =>
							 
								<tr key = {item}>
									<td>{item.id}</td>
									<td>{item.usertype}</td>
									<td>
										<button name="editsub" className="btn btn-info btn-sm" onClick={() => this.handleEditClick(item.id)} ><i className="fa fa-edit"></i></button>&nbsp;
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>
				  
							 )}
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Usertype;


// WEBPACK FOOTER //
// ./src/employee/Usertype/Usertype.js